import Api from "gurhan/helpers/Api";
import router from "@router";
import { BASE_URL } from "./BaseUrl";
import { buildAppLoginUrl } from "@/helpers/appUrl";

import { STATISTIC_PREFIX_URL } from "./Endpoints/Statistic";
import { REGION_PREFIX_URL } from "./Endpoints/Region";
//import { PRODUCT_PREFIX_URL } from "./Endpoints/Product";
import { PAYMENT_METHOD_PREFIX_URL } from "./Endpoints/PaymentMethod";
import { PAYMENT_SETTING_PREFIX_URL } from "./Endpoints/PaymentSetting";
//import { EMPLOYEE_PREFIX_URL } from "./Endpoints/Employee";
import { SALE_TARGET_PREFIX_URL } from "./Endpoints/SaleTarget";
// import { PARASUT_SYNC_PREFIX_URL } from "./Endpoints/ParasutSync";
import { MIKRO_SYNC_PREFIX_URL } from "./Endpoints/MikroSync";

const loginUrl = buildAppLoginUrl();

/**
 * Tüm requestler için yazılmış API HELPER module'üdür.
 * api.get(url);
 *
 * api.post(url, data);
 *
 * api.put(url, data)
 *
 * api.delete(url, data)
 *
 * api.token = String - Tüm requestlerde headers kısmına ekler.
 *
 * @param {object} Options - API bağlantı bilgileri
 *
 * @param {string} Options.baseUrl - Base url
 */
const api = new Api({
  baseUrl: BASE_URL, // api adresi,
  bearerToken: true, // bearer token kullanılacaksa true değilse false,
  errorStatus: [401, 403], // uygulama hangi hata code'larını aldığında login'e gönderilir.
  loginRouterName: "Login",
  loginUrl, // login için hangi url'e istek atacağını belirtir.
  vueRouter: router, // uygulamanın route bilgisini gönderir ve içerideki yönlendirmeleri yapar.
  cache: true,
  cacheTime: 1000 * 60 * 60 * 24, // cache'in süresi 24 saat
  cachableList: [
    STATISTIC_PREFIX_URL,
    REGION_PREFIX_URL,
    // PRODUCT_PREFIX_URL,
    PAYMENT_METHOD_PREFIX_URL,
    PAYMENT_SETTING_PREFIX_URL,
    //EMPLOYEE_PREFIX_URL,
    "Plan/GetMonthlyPlansByEmployee",
    "Customer?searchKey=&regionId=&employeeId=&isYearCustomer=&userType=&lastPlanFilter=&maxLongitude=&minLongitude=&maxLatitude=&minLatitude=",
    SALE_TARGET_PREFIX_URL,
    MIKRO_SYNC_PREFIX_URL,
    //PARASUT_SYNC_PREFIX_URL,
  ],
});

export default api;
